import * as React from "react";
import _ from "lodash";
import { ScrollView } from "react-native";

import useListVideos from "../../hooks/videos/useListVideos";
import { Video } from "../../types";
import { Info, Space, JustifyContent } from "../../styled-component";

import Layout from "../common/Layout";
import List from "../common/List";
import Text from "../common/Text";
import Button from "../common/PressableButton";
import Card from "../common/Card";

import VideoOne from "./VideoOne";

const minWidthStyle = {
  minWidth: "100%",
};

export interface VideoInputProps {
  value?: Video["id"];
  onChange: (value?: Video["id"]) => void;
}

function VideoInput({ value, onChange = _.noop }: VideoInputProps) {
  const videosQuery = useListVideos();

  return (
    <ScrollView horizontal contentContainerStyle={minWidthStyle}>
      <Info style={minWidthStyle}>
        <Layout.Column>
          <Space />

          <Layout.Row justifyContent={JustifyContent.Center}>
            <List.Async<Video>
              {...videosQuery}
              renderEmpty={() => <Text>No Videos</Text>}
              renderItem={({ item }: { item: Video; index: number }) => (
                <>
                  {(!value || value === item.id) && (
                    <>
                      <Space />
                      <Card>
                        <Button
                          onPress={() =>
                            onChange?.(!value ? item.id : undefined)
                          }
                          selected={value === item.id}
                        >
                          <Layout.Box size={1}>
                            <VideoOne video={item} />
                          </Layout.Box>
                        </Button>
                      </Card>
                    </>
                  )}
                </>
              )}
            />

            <Space />
          </Layout.Row>

          <Space />
        </Layout.Column>
      </Info>
    </ScrollView>
  );
}

export default VideoInput;
